// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__11UaX","label":"CategoryService_label__1SFBm","location":"CategoryService_location__2KYc5"};